


jQuery(window).on('load', function ($) {
  setInterval(function(){
    jQuery(".gpo-helptext").each(function(){
      var helptxt = jQuery( this ).html();
      jQuery( this ).find("span").addClass("helptxt");
      jQuery( this ).parent().find(".gpo-label").append(helptxt);
      jQuery( this ).remove();
    });
  }, 2000);

  setTimeout(function() {
    jQuery(".gpo-label").each(function(){
      jQuery( this ).append("<span class='label_bg'></span>");  
    });
  }, 2000);
  
});

$(document).ready(function() {

    /*$(document).on('click', '.gpo-label .label_bg', function() {
        if(!$(this).parent().parent().hasClass('radio_addon')){
          var $targetDiv = $(this).parent().next('.gpo-selected-values').next('div');
          $targetDiv.slideToggle();
        }
    });*/

    $(document).on('click', '.gpo-label .label_bg', function() {
      var $parent = $(this).parent().parent();
  
      if ($parent.hasClass('theater-arms')) {
        $parent.find('.gpo-choicelist').slideToggle();
      } else if ($parent.hasClass('throw-pillow')) {
        $parent.find('.gpo-choicelist').slideToggle();
      } else {
        var $targetDiv = $(this).parent().next('.gpo-selected-values').next('div');
        $targetDiv.slideToggle();
      }
    });
    
    setTimeout(function() {
      $(".dimensions_accordion").trigger("click");
      $(".accordion_addon #select-1 option").removeAttr("disabled");
    }, 2500);

    $(document).on("click", ".popup_link1", function(){
      $(".leather_guide_popup .gpo-modal").trigger("click");
    });

    setTimeout(function() {
        var product_title = $( ".product-block--title .product-title" ).text();
        console.log(product_title);
        $(".product_title input").val(product_title);
    }, 1500);

    $('#leather_guide_slide').scroll();
    $('.scroll_btn').click(function(){
      $("#leather_guide_slide").animate({
        scrollTop: 0
      }, 1000);
    });

    var pageURL = $(location).attr("href");
    pageURL += '/?show_chat';
    var chat_btn_link = "#!"
    $(".product-block--text a[title='/?show_chat']").attr("href",chat_btn_link);
    $(".product-block--text a[title='/?show_chat']").removeAttr("target");
    $(".product-block--text a[title='/?show_chat']").attr("id","pbt_chat_btn");

    

    /*setTimeout(function() {
      $(".mswatch_data_field").val("tester 123412");
    }, 3000);*/

    $("#cfpmodal .cfp-modal-body").prepend("<div class='popup_call'><a href='tel:(800) 262-1049'>(800) 262-1049</a></div>");
    $("#cfp_product_name").after("<p class='popup_caption'>Call us to order OR submit this form to receive a call from our team to assist you with placing your order over the phone.</div>");

    setTimeout(function() {
        $(".sp_product .sp_product_con").each(function(){
            var collection = $(this).find(".sp_vendor").text();
            console.log("test");
        });
    }, 2500);
    
});
var elem = document.querySelector('.subcollections-list__content');
if (elem) {
    var flkty = new Flickity(elem, {
        // Options, such as:
        cellAlign: 'left',
        contain: true,
        wrapAround: true
    });
}



var acc = document.getElementsByClassName("accordion");
var i;

for (i = 0; i < acc.length; i++) {
  acc[i].addEventListener("click", function() {
    this.classList.toggle("active");
    var panel = this.nextElementSibling;
    if (panel.style.maxHeight) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + "px";
    } 
  });
}